export enum LexerContext {
    DEFAULT,
    STRING
}
